module.exports = __webpack_public_path__ + "img/txocLogoHorizontal.c1332b17.svg";